import Home from "./pages/Home";

export default function Content() {
  return (
    <div className="content">
      <Home />
    </div>
  );
}
